export const formatDateByLocale = (date: any, locale: string): string => {
  if (!date) return "";
  try {
    const formatter: Intl.DateTimeFormat = new Intl.DateTimeFormat(locale, {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    const parsedDate = Date.parse("" + date);
    const formattedDate = formatter.format(parsedDate);
    return formattedDate;
  } catch (e) {
    return "" + date;
  }

  // return date.toLocaleString(locale, {
  //     day: "2-digit",
  //     month: "2-digit",
  //     year: "numeric",
  // });
};

export const formatDateTimeByLocale = (date: any, locale: string): string => {
  if (!date) return "";
  try {
    const formatter: Intl.DateTimeFormat = new Intl.DateTimeFormat(locale, {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
    const parsedDate = Date.parse("" + date);
    const formattedDate = formatter.format(parsedDate);
    return formattedDate;
  } catch (e) {
    return "" + date;
  }
};

export const formatDate = (date: string): string => {
  // Works with the following format:
  // yyyymmdd / ex: 20220101
  if (!date) return "";
  const year = date.slice(0, 4);
  const month = date.slice(4, 6);
  const day = date.slice(6, 8);
  return `${day}/${month}/${year}`;
}

export const isPilot = () => process.env.REACT_APP_BUILD_VERSION === "XXXX_Quality"; 

export const formatCurrency = (value: number, currency: string | undefined, lang: string): string => {
  return Intl.NumberFormat(lang, {
    style: "currency",
    currency: currency ?? "EUR",
    currencyDisplay: "code",
  }).format(value);
}
